<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense flat >
            <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-toolbar-title>{{company.name.caption}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip v-show="this.otherAttribs.length > 0" bottom open-delay="500">
              <span slot="activator">
                <v-btn icon>
                 <v-icon>face</v-icon>
                </v-btn>
              </span>
              <span>{{this.getOtherAttribsNameShort()}}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-scroll v-show="company && company.ogrn" md flat :offset="calcOffset(60, 104)" >
              <v-layout row wrap>
                <v-flex xs12 sm12>
                  <v-company-panel fill-height v-show="company && company.ogrn" :company="company" :notesAvailable="company && company.inn && getProfileHaveClient && favoriteLists!=null" :notesEditable="!accountNameShort"
                  :privateNotes=privateNotes :notes=notes :tags=tags :monitoring=monitoring :otherAttribs=otherAttribs :clientCompanyId=clientCompanyId :banks=banks
                  v-on:refresh="refreshCompanyProps()"
                  ></v-company-panel>
                </v-flex>
                <v-flex xs12 sm6 v-if="refCode && clientCompanyId!=null">
                  <v-contacts-panel fill-height :refCode="refCode"></v-contacts-panel>
                </v-flex>
                <v-flex xs12 sm6 v-if="refCode && clientCompanyId!=null">
                  <v-banks-panel fill-height :banks="banks"></v-banks-panel>
                </v-flex>
                <v-flex v-if="company && !(company.status && company.status.kind === 'GOOD')" xs12 sm12>
                  <v-reorg-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-reorg-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-assignees-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-assignees-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-branches-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-branches-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-activities-panel fill-height v-show="company && company.ogrn" :activities="company.activities"></v-activities-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-licenses-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-licenses-panel>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-trademarks-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-trademarks-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-holders-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn" :capital="company.capital" :holderRegister="company.holderRegister"></v-holders-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-children-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-children-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-manageds-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-manageds-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-fin-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-fin-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-tax-pay-panel fill-height v-show="company && company.ogrn" :model="{ogrn: company.ogrn, staffNumber: company.staffNumber, taxOffence: company.taxOffence ? company.taxOffence.value : null}"></v-tax-pay-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-arrears-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn"></v-arrears-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-enforcement-debts-panel fill-height v-show="company && company.inn" :inn="company.inn"></v-enforcement-debts-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-enforcements-panel fill-height v-show="company && company.inn" :inn="company.inn"></v-enforcements-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-records-panel fill-height v-show="company && company.ogrn" :records="company.records"></v-records-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-credentinals-panel fill-height v-show="company && (company.tax || company.pf || company.fss || company.registration)" :reg="company.registration" :tax="company.tax" :pf="company.pf" :fss="company.fss"></v-credentinals-panel>
                </v-flex>
                <v-flex xs12 sm6 >
                  <v-history-panel fill-height v-show="company && company.ogrn" :ogrn="company.ogrn" :clientId="company.clientId"></v-history-panel>
                </v-flex>
                <v-flex xs12 sm6 >
                  <v-links-panel fill-height v-show="company && company.inn" :inn="company.inn" :clientId="company.clientId"></v-links-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-client-preview-panel fill-height v-if="company && company.inn" :inn="company.inn"></v-client-preview-panel>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-visit-panel fill-height v-if="company && company.reference && company.reference.ref && getProfileHaveClient" :topCount="5" :refCode="company.reference.ref"></v-visit-panel>
                </v-flex>
              </v-layout>
          </v-card-scroll>
          <v-card-actions v-show = "mode !== 'mainPage'">
            <v-layout row wrap>
              <v-flex py-1 v-show="company && company.inn && !company.clientId && !this.accountNameShort">
                <v-component :is="createButton('Приглашение', 'mail_outline', 'Пригласить в Систему АТЛАНТ-СМАРТ', invite)" />
              </v-flex>
              <v-flex py-1 v-show="company && company.ogrn">
                <v-component :is="createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', copyLink)" />
              </v-flex>
              <v-flex py-1 v-show="company && company.inn && getProfileHaveClient && !favoriteLists && !this.accountNameShort">
                <v-component :is="createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', addFavorite)" />
              </v-flex>
              <v-flex py-1 v-show="company && company.inn && getProfileHaveClient && favoriteLists && !this.accountNameShort">
                <v-component :is="createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', dialogOpenFavorite)" />
              </v-flex>
            </v-layout>
          </v-card-actions>

        </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import server from '../../api/server'
  import formats from '../../api/formats'
  import vCardScroll from '../common/CardScroll'
  import vClientPreview from '../client/ClientPreview'
  import vClientPreviewPanel from './ClientPreviewPanel'
  import vCompanyPanel from './CompanyPanel'
  import vActivitiesPanel from './ActivitiesPanel'
  import vTaxPayPanel from './TaxPayPanel'
  import vManagedsPanel from './ManagedsPanel'
  import vChildrenPanel from './ChildrenPanel'
  import vHoldersPanel from './HoldersPanel'
  import vPanelTitle from './PanelTitle'
  import vArrearsPanel from './ArrearsPanel'
  import vAssigneesPanel from './AssigneesPanel'
  import vBranchesPanel from './BranchesPanel'
  import vEnforcementsPanel from './EnforcementsPanel'
  import vEnforcementDebtsPanel from './EnforcementDebtsPanel'
  import vLicensesPanel from './LicensesPanel'
  import vTrademarksPanel from './TrademarksPanel'
  import vReorgPanel from './ReorgPanel'
  import vRecordsPanel from './RecordsPanel'
  import vHistoryPanel from './HistoryPanel'
  import vNotesForm from './NotesForm'
  import vFinPanel from './FinPanel'
  import vVisitPanel from './VisitPanel'
  import vContactsPanel from '../info/ContactsPanel'
  import vBanksPanel from '../info/BanksPanel'
  import vCredentinalsPanel from '../info/CredentinalsPanel'
  import vLinksPanel from '../info/LinksPanel'
  import dialogs from '../common/dialogs'

  export default {
    name: 'client-page',
    components: {vCardScroll, vClientPreview, vClientPreviewPanel, vCompanyPanel, vActivitiesPanel, vTaxPayPanel, vPanelTitle, vManagedsPanel, vChildrenPanel, vHoldersPanel, vArrearsPanel, vAssigneesPanel, vBranchesPanel, vEnforcementsPanel, vEnforcementDebtsPanel, vLicensesPanel, vTrademarksPanel, vReorgPanel, vRecordsPanel, vHistoryPanel, vFinPanel, vVisitPanel, vContactsPanel, vBanksPanel, vCredentinalsPanel, vLinksPanel},
    data: () => ({
      clientCompanyId: null,
      refCode: null,
      banks: [],
      company: null,
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      monitoring: false,
      accountNameShort: null,
      otherAttribs: [],
      isReorg: false
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      }
    },
    created () {
      this.initCompany()
    },
    mounted () {
      if (this.itemId) {
        console.log('fetchCompanyProps mounted', this.itemId)
        this.fetchCompanyProps(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          console.log('fetchCompanyProps watch', newVal, oldVal)
          this.fetchCompanyProps(newVal)
        } else {

        }
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        console.log('getProfileHaveClient', newVal, oldVal)
        this.refreshCompanyProps()
      }
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        getClientUrl: 'getClientUrl',
        getRefToUrl: 'getRefToUrl',
        getProfileHaveClient: 'getProfileHaveClient',
        getClientProfile: 'getClientProfile',
        getClientCompany: 'getClientCompany',
        getIsAuthorized: 'getIsAuthorized',
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs'
      })
    },
    methods: {
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      getOtherAttribsNameShort () {
        var result = this.otherAttribs.reduce((s, i) => s + i.accountNameShort + ', ', '')
        return result.length > 2 ? result.slice(0, -2) : result
      },
      createButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<v-tooltip top open-delay="500">
              <div slot="activator">
                <v-btn flat  @click="action">
                  <v-icon left>{{icon}}</v-icon>{{caption}}
                </v-btn>
              </div>
              <span>{{hint}}</span>
            </v-tooltip>`
        )
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action
            }
          }
        }
      },
      fetchCompanyProps (inn) {
        this.initCompany()
        this.$store.dispatch('getCompanyProps', inn).then((data) => {
          this.company = data
          if (this.company) {
            this.fetchFavoriteProps(this.company.ogrn)
            this.fetchClientCompany()
          }
        })
      },
      fetchFavoriteProps (ogrn) {
        let refCode = formats.isOgrn(ogrn) ? 'ogrn:' + ogrn : null
        this.$store.dispatch('getFavoriteRefs', refCode).then((data) => {
          if (!Array.isArray(data) || data.length < 1) {
            console.log('fetchCompanyProps', data)
            return
          }
          if (this.getProfileHaveClient) {
            this.clientCompanyId = data[0].clientCompanyId
            this.banks = data[0].banks
            this.favoriteLists = data[0].tags
            this.privateNotes = data[0].privateNotes
            this.notes = data[0].notes
            this.tags = data[0].tags
            this.monitoring = data[0].monitoring
            this.accountNameShort = data[0].accountNameShort
            this.otherAttribs = data.slice(1)
            this.refCode = refCode
          } else {
            this.clientCompanyId = null
            this.banks = []
            this.favoriteLists = null
            this.privateNotes = null
            this.notes = null
            this.tags = null
            this.monitoring = false
            this.accountNameShort = null
            this.otherAttribs = []
            this.refCode = null
          }
        })
      },
      fetchClientCompany () {
        if (this.getProfileHaveClient && !this.getClientCompany) {
          this.$store.dispatch('getCompanyProps', this.profile.clientInn).then((data) => {
            this.$store.commit('setClientCompany', data)
            this.$store.dispatch('fetchClientProfile')
          })
        }
      },
      refreshCompanyProps () {
        if (this.itemId) {
          this.fetchCompanyProps(this.itemId)
        }
      },
      invite () {
        var email = ''
        var subject = 'Приглашение работать через Систему "АТЛАНТ-СМАРТ"'
        var emailHeader = this.company.head ? this.company.head.firstName + ' ' + this.company.head.middleName + ',' : 'Господа,'
        var emailBody = emailHeader +
        '\n' +
        '\n Предлагаем Вам использовать Систему "АТЛАНТ-СМАРТ" для ' +
        '\n\t продолжения нашего делового общения,' +
        '\n\t депонирования файлов и ' +
        '\n\t оперативного заключения договоров в электронной форме.' +
        '\n' +
        '\n Ссылка для регистрации в системе:' +
        '\n https://atlant-smart.ru/#/register' +
        '\n' +
        '\n С уважением, ' + this.profile.nameShort +
        '\n' + this.profile.clientNameShort
        this.$store.dispatch('mailTo', {email: email, subject: subject, emailBody: emailBody})
      },
      initCompany () {
        this.company = {
          ogrn: null,
          ogrnDate: null,
          releaseDate: null,
          inn: null,
          kpp: null,
          nameShort: '',
          name: '',
          address: '',
          clientId: null,
          activities: [],
          head: {
            position: '',
            lastName: '',
            firstName: '',
            middleName: ''
          }
        }
      },
      copyLink () {
        let refCode = formats.getValue(this.company, ['reference', 'ref'])
        this.$store.dispatch('copyCompanyLink', this.getClientUrl(refCode))
      },
      addFavorite () {
        let refCode = formats.getValue(this.company, ['reference', 'ref'])
        if (refCode) {
          this.$store.dispatch('addFavoriteCompany', {refCode: refCode, tags: this.tags ? this.tags.map(t => t.id) : null})
          this.refreshCompanyProps()
        }
      },
      dialogOpenFavorite () {
        var self = this
        const setNotes = function (data) {
          // if (self.notes || self.notes && self.notes.localeCompare(data) !== 0) {
          self.refreshCompanyProps()
          // }
        }
        dialogs.register('v-notes-form', vNotesForm)
        var comp = { template: `
          <v-notes-form v-on:input="setNotes" v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-notes-form>
        `,
          data () {
            return {
              model: {clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.company, notes: self.notes, privateNotes: self.privateNotes, tags: self.tags, monitoring: self.monitoring},
              setNotes: setNotes,
              fullscreen: self.$vuetify.breakpoint.xsOnly
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClientPage.vue?07d628c5